import {
    getDisplayValue,
    windCardinal
} from '../format-display-value';

import {
    mapWindSpeedToClass
} from '../query-colour-mapper';

function samplePoints(array, numPoints) {
    const arrayLength = array.length;
    if(numPoints >= arrayLength) {
        return array;
    }

    const step = (arrayLength - 1) / (numPoints - 1);
    const samplePoints = [];

    for(let i = 0; i < numPoints; i++) {
        const index = Math.round(i * step);
        samplePoints.push(array[index]);
    }

    return samplePoints;
}

/**
 * Hourly data should have the following structure:
 * {
 *      DF: "string",
 *      DateTime: "string",
 *      Direction: "string",
 *      FBI: "string",
 *      FDR: "string",
 *      Humidity: "string",
 *      Speed: "string",
 *      Temperature: "string"
 * }
 * 
 * NOTE ON ROTATION
 * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate
 * 
 * CSS's `rotate()` function rotates the element clockwise by the specified 
 * amount (deg).
 * In aviation however, the wind direction (e.g. 110deg) always
 * points in the direction the wind is COMING FROM, whereas the
 * arrow (or wind sock) will always point in the direction the wind
 * is GOING.
 * 
 * If you understand that, then the modulo math will make a lot more sense.
 * 
 * @param {*} hourlyData 
 * @param {*} detailsContainer 
 */
export function drawWindDirTable(hourlyData, detailsContainer, chartHeight, numArrows=26) {
    // const numArrows = 26;

    // Sample evenly distributed points from the hourly data
    const samples = samplePoints(hourlyData, numArrows);

    const tempContainer = $(`<div class="wind-dir-container-style"></div>`);
    // tempContainer.css({
    //     position: 'relative'
    // })

    const dateFormatOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
    }

    const popupContainer = $(`<div id="wind-dir-table-popup-id"></div>`)
    popupContainer.css({
        display: 'none',
        position: 'fixed',
        width: `200px`,
        minHeight: `40px`,
        backgroundColor: `white`,
        borderRadius: `4px`,
        borderStyle: `solid`,
        borderWidth: `1px`,
        borderColor: `var(--rfs-brown)`,
        zIndex: 9999
    });

    tempContainer.append(popupContainer);

    samples.forEach((item) => {
        const dateVal = new Date(item['DateTime']);
        const windSpeedVal = getDisplayValue(item['Speed'], 'WindSpeed');
        const windDirVal = windCardinal(+item['Direction']);

        // Initially rotate the icon backward 45 degrees (because by default its
        // on a 45 degree angle)
        // https://icons.getbootstrap.com/icons/cursor-fill/
        let rotation = -45;
        
        // Add in the direction the wind is COMING FROM
        rotation += +item['Direction']
        
        // Add 180 degrees to get the direction the wind is GOING
        rotation += 180

        // Modulo that by 360 degrees to make sure it's valid
        rotation %= 360

        // Get the wind speed colour map
        const colourClass = mapWindSpeedToClass(item['Speed']);

        const colourContainer = $(`<div class="${colourClass}" style="display:flex;padding:1px;"></div>`)

        const rotationStyle = `transform:rotate(${rotation}deg);` +
                `transform-origin: center;`

        const cursor = $(`<i class="bi bi-cursor-fill" style="${rotationStyle}"></i>`);

        // Attach a hover listener
        colourContainer.on({
            mouseenter: function () {
                const windDirTablePopup = $(`#wind-dir-table-popup-id`);

                //stuff to do on mouse enter
                var position = $(this).offset();
                var xPos = position.left;
                var yPos = position.top + 30; // Offset to bring it below the icon 

                var popupWidth = windDirTablePopup.outerWidth();
                var popupHeight = windDirTablePopup.outerHeight();
                var viewportWidth = $(window).width();
                var viewportHeight = $(window).height();

                // Adjust position to keep the popup inside the viewport
                if (xPos + popupWidth > viewportWidth) {
                    xPos = viewportWidth - popupWidth - 10; // 10px padding from the edge
                }
                if (yPos + popupHeight > viewportHeight) {
                    yPos = viewportHeight - popupHeight - 10; // 10px padding from the edge
                }

                const dataInner = $(`<div>` + 
                    `<div>${dateVal.toLocaleString('en-US', dateFormatOptions)}</div>` +
                    `<div>Speed : ${windSpeedVal}</div>` +
                    `<div>Direction : ${windDirVal}</div>` + 
                `</div>`);
                dataInner.css({
                    padding: `2px`,
                    fontSize: `12px`
                })

                windDirTablePopup.append(dataInner);

                windDirTablePopup.css({
                    left: xPos + "px",
                    top: yPos + "px",
                    display: "block" // Make it visible
                });

                
            },
            mouseleave: function () {
                const windDirTablePopup = $(`#wind-dir-table-popup-id`);
                windDirTablePopup.empty();
                windDirTablePopup.css({
                    display: 'none'
                })
            }
        });


        
        colourContainer.append(cursor); 
        tempContainer.append(colourContainer);
    });
    
    detailsContainer.append(tempContainer);
    // const cursor = $(`<i class="bi bi-cursor-fill"></i>`);
    // detailsContainer.append(cursor);
}